import PortfolioGallery from './PortfolioGallery'

export default PortfolioGallery
